export const SEARCH_WHITELISTED_IPS = 'SEARCH_WHITELISTED_IPS';
export const ADD_WHITELISTED_IP = 'ADD_WHITELISTED_IP';
export const REMOVE_WHITELISTED_IP = 'REMOVE_WHITELISTED_IP';
export const REMOVE_ALL_WHITELISTED_IP = 'REMOVE_ALL_WHITELISTED_IP';
export const IMPORT_WHITELISTED_IPS = 'IMPORT_WHITELISTED_IPS';
export const RESET_WHITELISTED_IPS_SEARCH_PARAMS = 'RESET_WHITELISTED_IPS_SEARCH_PARAMS';
export const DELETE_IP_IN_STORE = 'DELETE_IP_IN_STORE';